import {autorun} from 'mobx';
import Sheet from './Sheet';
import Page from './Page';
import pageGraphics from './pageGraphics';

const PAGE_COLOR = 0xFFE673;
const PAGE_HOVER_COLOR = 0xAA9539;
const PAGE_TEXT_COLOR = 0x000000;

export default class RendererStore {
  store = null;
  container = null;
  pagesContainer = new PIXI.Container();
  pageTextures = {};
  renderer = null;
  stage = null;
  perf = 0;

  constructor(store) {
    this.store = store;
    const {sheet, canvas} = store;
    this.renderer = new PIXI.autoDetectRenderer(sheet.width, sheet.height, {
      transparent: false,
      backgroundColor: 0xFF00FF,
      antialias: true
    });

    this.stage = new PIXI.Container();
    this.stage.width = sheet.width;
    this.stage.height = sheet.height;
    this.stage.scale.set(canvas.scale);
    this.renderer.render(this.stage);

    new Sheet(this.animate, this.stage, store);

    this.stage.addChild(this.pagesContainer);

    this.animate();

    autorun(() => {
      const {width, height, scale} = store.canvas;
      this.renderer.resize(width, height);
      this.stage.scale.set(scale);
    });

    autorun(this.updateSignature);
  }

  animate = () => {
    const start = performance.now();
    this.renderer.render(this.stage);
    const timeTaken = performance.now() - start;
    if (timeTaken > 10) console.log('redraw took longer than 10ms', timeTaken);
    // requestAnimationFrame(this.animate);
  };

  setContainer(container) {
    this.container = container;
    container.appendChild(this.renderer.view);
  }

  updatePages = () => {
    const {page} = this.store;
    const {pageTextures} = this;

    // No need to update if the page stayed the same
    if (pageTextures.width === page.width && pageTextures.height === page.height && pageTextures.amount === page.amount) {
      return;
    }

    console.log('updatePages');

    pageTextures.pages = {};
    pageTextures.width = page.width;
    pageTextures.height = page.height;
    pageTextures.amount = page.amount;

    // Create textures for each page
    if (page.amount <= 0) return;

    for (let i = 1; i <= page.amount; i++) {
      pageTextures.pages[i] = {};
      pageTextures.pages[i].texture = pageGraphics(this.renderer, page, i, PAGE_COLOR, PAGE_TEXT_COLOR);
      pageTextures.pages[i].hoverTexture = pageGraphics(this.renderer, page, i, PAGE_HOVER_COLOR, PAGE_TEXT_COLOR);
    }
  };

  updateSignature = () => {
    console.log('updateSignature');
    const start = performance.now();

    const {signature} = this.store;
    const {pageTextures, pagesContainer} = this;

    pagesContainer.removeChildren();
    pagesContainer.width = signature.width;
    pagesContainer.height = signature.height;
    pagesContainer.position.set(signature.x, signature.y);

    this.updatePages();

    if (pageTextures.amount > 0) {
      signature.pages.map(page => new Page(
        this.animate,
        pageTextures.pages[page.pageNr],
        pagesContainer,
        page));
    } else {
      this.renderError(pagesContainer, "Amount of pages is invalid");
    }

    const timeTaken = performance.now() - start;
    console.log('creating data for new signature took', timeTaken);

    this.animate();
  };

  renderError = (container, error) => {
    const errorText = new PIXI.Text(error);
    errorText.anchor.set(0.5);
    errorText.position.set(this.store.sheet.width / 2, this.store.sheet.height / 2);
    container.addChild(errorText);
  };
}


// WEBPACK FOOTER //
// ./src/views/SheetCalculator/Pixi/RendererStore.js